import React from "react"
import TernaryCell from "./TernaryCell"
import { StyledSelectField } from "./styles"
import { toBool } from "../../../utils/stringHelpers"

const RatingBoolFieldCell = ({
  value,
  column: { id },
  row: {
    original: { locked }
  }
}) => {
  return (value === null || value === undefined) && !toBool(locked) ? (
    <StyledSelectField
      name={id}
      options={[
        ["true", "Yes"],
        ["false", "No"]
      ]}
      blank="Select"
    />
  ) : (
    <TernaryCell value={value} icon={false} />
  )
}

export default RatingBoolFieldCell
